import type { GigsafeConfig } from 'src/interfaces/gigsafeConfig'
import type { State } from '../reducers/types'

/**
 * Every selector here returns a stored value by reference. Never build an object or array
 * literal in a selector — each consuming `useSelector` would re-render on every dispatch.
 * Form-shaped derivation belongs in the mapper, called under `useMemo`.
 */
export const getGigsafeConfig = (state: State): GigsafeConfig | null => {
  return state.gigsafeConfig.config
}

export const getGigsafeConfigPartnerId = (state: State): string | null => {
  return state.gigsafeConfig.partnerId
}

export const getGigsafeConfigLoading = (state: State): boolean => {
  return state.gigsafeConfig.loading
}

export const getGigsafeConfigLoaded = (state: State): boolean => {
  return state.gigsafeConfig.loaded
}

export const getGigsafeConfigError = (state: State): string | null => {
  return state.gigsafeConfig.error
}

export const getGigsafeConfigSaving = (state: State): boolean => {
  return state.gigsafeConfig.saving
}
